/* eslint-disable react-hooks/exhaustive-deps */
import { Search, Plus, RotateCw } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import SelectInput from '../../components/Input/SelectInput'
import { BadgeStatusPrList } from '../../components/atoms/StatusLabel'
import TablePagination from '../../components/atoms/Table/TablePagination'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import api from '../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import { convertDateWithTime } from '../../helpers/constants'

const cardFilterStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  padding: '1.5rem',
  marginBottom: '1.5rem'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '45px',
    height: '45px',
    borderRadius: '10px',
    border: '1px solid #e9ecef',
    backgroundColor: '#ffffff',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    borderColor: state.isFocused ? '#f89d1d' : '#e9ecef',
    '&:hover': {
      borderColor: '#f89d1d'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 12px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#adb5bd',
    fontSize: '0.9rem'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '0.9rem',
    color: '#333'
  })
}

function ReplenishmentPage() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [warehouses, setWarehouses] = useState([])
  const [filterWarehouse, setFilterWarehouse] = useState(null)
  const [filterStatus, setFilterStatus] = useState(null)
  const [filterCode, setFilterCode] = useState('')
  const [debouncedCode, setDebouncedCode] = useState('')

  const [data, setData] = useState({
    values: [],
    metadata: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })

  const [form, setForm] = useState({
    form_warehouse_id: state?.form_warehouse_id || null,
    type: state?.type || null
  })

  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState({
    data: false,
    submit: false
  })

  useEffect(() => {
    if (state?.warehouse_id) {
    }
    if (state?.q) setFilterCode(state.q)
    if (state?.status) {
      const statusOpt = statusOptions.find((opt) => opt.value === state.status)
      if (statusOpt) setFilterStatus(statusOpt)
    }
  }, [])

  useEffect(() => {
    fetchWarehouses()
  }, [])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedCode(filterCode)
      setData((prev) => ({
        ...prev,
        metadata: { ...prev.metadata, current_page: 1 }
      }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [filterCode])

  useEffect(() => {
    if (filterWarehouse) {
      fetchData()
    } else {
      setData((prev) => ({
        ...prev,
        values: [],
        metadata: {
          ...prev.metadata,
          current_page: 1,
          total_row: 0,
          total_page: 0
        }
      }))
    }
  }, [
    debouncedCode,
    filterWarehouse,
    filterStatus,
    data.metadata.per_page,
    data.metadata.current_page
  ])

  const handleModal = (isPrevState = false) => {
    const isOpenValue = !isOpen
    setIsOpen(isOpenValue)
    if (!isPrevState && (form.form_warehouse_id || form.type)) {
      setForm({
        warehouse_id: null,
        type: null
      })
    }
    if (!isOpenValue && state?.isCancel) {
      navigate('/replenishment', {
        state: {
          q: filterCode,
          warehouse_id: filterWarehouse?.value,
          status: filterStatus?.value
        }
      })
    }
  }

  const fetchData = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, data: true }))
      const params = {
        q: debouncedCode,
        warehouse_id: filterWarehouse?.value,
        status: filterStatus?.value,
        per_page: data?.metadata?.per_page || 10,
        page: data?.metadata?.current_page || 1
      }
      const res = await api.get('/replenish', {
        params
      })
      const { data: dataResponse, metadata: metadataResponse } = res.data
      setData({
        values: dataResponse,
        metadata: metadataResponse
      })
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, data: false }))
    }
  }

  const handlePageChange = (val) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: val.selected + 1
      }
    }))
    window.scrollTo(0, 0)
  }

  const handleOnChangeMeta = (e) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: 1,
        per_page: parseInt(e.target.value, 10)
      }
    }))
    window.scrollTo(0, 0)
  }

  const handleForm = (value, name) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value
    }))
  }

  const handleSubmit = () => {
    setIsOpen(false)
    const selectedWh = warehouses.find((w) => w.id === form.form_warehouse_id)
    navigate('/replenishment/create', {
      replace: true,
      state: {
        q: filterCode,
        warehouse_id: filterWarehouse?.value,
        status: filterStatus?.value,
        form_warehouse_id: form.form_warehouse_id,
        warehouse_name: selectedWh?.warehouse_name || '',
        type: form.type
      }
    })
  }

  const fetchWarehouses = async () => {
    try {
      const res = await api.get(`/master/warehouses/all`, {
        params: {
          is_parent: true,
          forUser: 1
        }
      })
      const { data } = res
      if (data.success) {
        setWarehouses(data.data)
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const propDisableButtonModal = useCallback(() => {
    if (
      form.type === '' ||
      !form.type ||
      form.warehouse_id === '' ||
      !form.form_warehouse_id
    )
      return true
    return false
  }, [form])

  const statusOptions = [
    { value: 'waiting', label: 'Waiting' },
    { value: 'ongoing', label: 'On Going' },
    { value: 'finish', label: 'On Finish' }
  ]

  const resetFilter = () => {
    setFilterCode('')
    setFilterWarehouse(null)
    setFilterStatus(null)
    setData((prev) => ({
      ...prev,
      metadata: { ...prev.metadata, current_page: 1 }
    }))
  }

  const columns = [
    { key: 'code', label: 'Ticket' },
    { key: 'warehouse_name', label: 'Warehouse' },
    { key: 'type', label: 'Type', className: 'text-capitalize' },
    {
      key: 'created_at',
      label: 'Created Date',
      className: 'text-end',
      component: (value) =>
        value?.created_at !== '-' && value?.created_at
          ? convertDateWithTime(value?.created_at, 'DD-MM-YYYY, HH:mm:ss')
          : '-'
    },
    {
      key: 'finish_at',
      label: 'Finished Date',
      className: 'text-end',
      component: (value) =>
        value?.finished_at !== '-' && value?.finished_at
          ? convertDateWithTime(value?.finished_at, 'DD-MM-YYYY, HH:mm:ss')
          : '-'
    },
    {
      key: 'status',
      label: 'Status',
      className: 'text-end',
      component: (value) => (
        <div key={value?.id} className="d-flex justify-content-end">
          <BadgeStatusPrList text={value?.status || 'done'} />
        </div>
      )
    },
    {
      key: 'action',
      label: 'Action',
      className: 'text-end',
      component: (value) => (
        <div key={value?.id}>
          <Button
            variant="light"
            className="text-primary border rounded p-2"
            size="sm"
            onClick={() => {
              navigate(`/replenishment/detail/${value.id}`, {
                state: {
                  q: filterCode,
                  warehouse_id: filterWarehouse?.value,
                  status: filterStatus?.value
                }
              })
            }}
            style={{ width: '35px', height: '35px' }}
          >
            <Search size={14} />
          </Button>
        </div>
      )
    }
  ]

  useEffect(() => {
    if (state?.isCancel) {
      handleModal(true)
    }
  }, [state?.isCancel])

  return (
    <>
      <Toaster />
      <div className="container-fluid px-4 mb-5">
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 className="header-title-style">Replenishment</h3>
          </Col>
          <Col className="text-end">
            <Button
              variant="transparent"
              className="btn-primary-orange rounded px-3 me-2"
              onClick={() => handleModal()}
              style={{ fontSize: '0.85rem' }}
            >
              <Plus size={16} className="me-2" />
              Create
            </Button>
            <Button
              variant="light"
              className="text-secondary fw-bold rounded px-3 border"
              onClick={resetFilter}
              style={{ fontSize: '0.85rem' }}
            >
              <RotateCw size={16} className="me-2" />
              Reset Filters
            </Button>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="gy-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label style={labelStyle}>Search By Code</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    value={filterCode}
                    onChange={(e) => setFilterCode(e.target.value)}
                    placeholder="Search Code..."
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Label style={labelStyle}>Warehouse</Form.Label>
              <Select
                isClearable
                value={filterWarehouse}
                onChange={(option) => {
                  setFilterWarehouse(option)
                  setData((prev) => ({
                    ...prev,
                    metadata: { ...prev.metadata, current_page: 1 }
                  }))
                }}
                options={warehouses.map((w) => ({
                  value: w.id,
                  label: w.warehouse_name
                }))}
                placeholder="All Warehouses"
                isSearchable
                styles={customStyles}
              />
            </Col>
            <Col md={4}>
              <Form.Label style={labelStyle}>Status</Form.Label>
              <Select
                isClearable
                value={filterStatus}
                onChange={(option) => {
                  setFilterStatus(option)
                  setData((prev) => ({
                    ...prev,
                    metadata: { ...prev.metadata, current_page: 1 }
                  }))
                }}
                options={statusOptions}
                placeholder="All Status"
                styles={customStyles}
              />
            </Col>
          </Row>
        </Card>

        <Row>
          <Col md={12}>
            <Table
              responsive
              hover
              className="shadow-sm bg-white"
              style={{
                fontSize: '0.9rem',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  {columns.map((column) => (
                    <th
                      className={`align-middle p-2 ${column.className || ''}`}
                      key={column.key}
                      style={tableHeaderStyle}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading.data && (
                  <tr>
                    <td colSpan={columns.length} className="p-5 text-center">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading.data && data?.values?.length === 0 && (
                  <tr>
                    <td
                      colSpan={columns.length}
                      className="p-5 text-center text-muted fw-bold"
                    >
                      No data
                    </td>
                  </tr>
                )}
                {!loading.data &&
                  data?.values?.length > 0 &&
                  data?.values?.map((item, index) => (
                    <tr
                      key={`${item.id}-${index}`}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      {columns.map((column) => (
                        <td
                          key={column.key}
                          className={`align-middle p-2 ${column.className || ''}`}
                        >
                          {column.component && column.component(item)}
                          {!column.component && item[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3 border-top-0" colSpan={columns.length}>
                    <TablePagination
                      meta={data.metadata}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>

        <ModalStockAdjustment
          show={isOpen}
          onHide={() => handleModal()}
          title="Create Replenishment"
          size="md"
          backdrop="static"
        >
          <Modal.Body className="my-2">
            <div className="d-flex flex-column gap-2">
              <p className="text-muted fs-6">
                Make sure there are no other activities beside this!
              </p>
              <p className="text-muted fs-6" style={{ marginTop: '-0.5rem' }}>
                Select warehouse to create replenishment
              </p>
              <div style={{ marginTop: '-0.5rem' }}>
                <SelectInput
                  label="warehouse"
                  name="warehouse"
                  id="warehouse"
                  handleChange={(e) =>
                    handleForm(e.target.value, 'form_warehouse_id')
                  }
                  options={
                    warehouses?.map((warehouse) => ({
                      value: warehouse.id,
                      label: warehouse.warehouse_name
                    })) || []
                  }
                  value={form.form_warehouse_id || ''}
                  required={true}
                />
              </div>
              <SelectInput
                label="Replenish Type"
                name="replenish_type"
                id="replenish_type"
                handleChange={(e) => handleForm(e.target.value, 'type')}
                options={[
                  { value: 'auto', label: 'Auto' },
                  { value: 'horizontal', label: 'Horizontal' },
                  { value: 'vertical', label: 'Vertical' }
                ]}
                value={form.type || ''}
                required={true}
              />
            </div>
            <Modal.Footer>
              <hr />
              <div className="d-flex justify-content-end">
                <Button
                  variant="transparent"
                  className={`${
                    propDisableButtonModal()
                      ? 'btn-secondary opacity-25'
                      : 'btn-primary-orange'
                  }`}
                  onClick={handleSubmit}
                  disabled={propDisableButtonModal()}
                >
                  Next
                </Button>
              </div>
            </Modal.Footer>
          </Modal.Body>
        </ModalStockAdjustment>
      </div>
    </>
  )
}

export default ReplenishmentPage
